import { i18nConstants } from '@tweddle-se-team/common/constants'
import useTranslation from '@/hooks/useTranslation'
import React, { useRef, useEffect } from 'react'
import CustomGrid from '@/components/shared/customGrid'
import { ActionButton } from '@/components/styles'

const { LANGUAGES } = i18nConstants

function LanguageSelector({ languages, locale, changeLocale = () => {} }) {
  const t = useTranslation()
  const firstButtonRef = useRef(null)
  const langs = languages && Object.keys(languages).length ? LANGUAGES.filter(l => !!languages[l.code]) : LANGUAGES

  useEffect(() => {
    if (firstButtonRef.current) {
      firstButtonRef.current.focus()
    }
  }, [])

  const gridItems = langs.map(({ code, label }, index) => {
    const isCurrent = code === locale
    return (
      <ActionButton
        key={code}
        ref={index === 0 ? firstButtonRef : undefined}
        block
        onClick={() => !isCurrent && changeLocale(code)}
        aria-pressed={isCurrent ? 'true' : undefined}
        appearance={isCurrent ? 'primary' : 'default'}
      >
        {t(label, label)}
      </ActionButton>
    )
  })
  return <CustomGrid items={gridItems} />
}

export default LanguageSelector
